import { Text } from '@ui-furniture/elements';
import { currencyFormatter } from '@ui-furniture/lib/utils/data-transform/currency-formatter';
import { FontSizeProp, StyledProps, x } from '@ui-furniture/style';

export const Price = ({
  price,
  symbol = '£',
  symbolFontSize = 'md',
  priceFontSize = 'xl',
  symbolGap = '2px',
  ...rest
}: {
  price: number;
  symbol?: string;
  symbolFontSize?: FontSizeProp;
  priceFontSize?: FontSizeProp;
  symbolGap?: string;
} & StyledProps) => (
  <Text fontSize={priceFontSize} my='md' {...rest}>
    <x.span fontSize={symbolFontSize} mr={symbolGap}>
      {symbol}
    </x.span>
    {currencyFormatter.format(price, { removeSymbol: true })}
  </Text>
);
